'use client';

import { FAQChatbot as FAQChatbotCore,type FAQChatbotProps } from '@kottonseed/faq-chatbot';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import { useFeatureFlag } from 'src/libs/feature-flags/client';
import { useAppDispatch } from 'src/store/client/config';
import { modalActions } from 'src/store/client/slices/modalSlice';

interface FAQChatbotWrapperProps {
  variant?: FAQChatbotProps['variant'];
}

export function FAQChatbot({ variant }: FAQChatbotWrapperProps) {
  const { isEnabled } = useFeatureFlag('faq-chatbot');
  const router = useRouter();
  const dispatch = useAppDispatch();

  const navigate = useCallback((href: string) => {
    router.push(href);
  }, [router]);

  const requestExitConfirm = useCallback<FAQChatbotProps['requestExitConfirm']>((config) => {
    dispatch(modalActions.openConfirmModal({
      icon: 'danger',
      title: config.title,
      description: config.description,
      closeText: config.closeText,
      confirmText: config.confirmText,
      onClose: config.onCancel,
      onConfirm: config.onConfirm,
    }));
  }, [dispatch]);

  if (!isEnabled) return null;

  return <FAQChatbotCore variant={variant} navigate={navigate} requestExitConfirm={requestExitConfirm} />;
}
